import { z } from 'zod';


z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type' && issue.received === 'undefined') {
    return { message: 'Este campo é obrigatório' }
  }

  return { message: ctx.defaultError }
})

export const usersSchema = z.object({

  id: z
    .number()
    .optional(),

  status: z
    .number()
    .optional(),

  nome: z
    .string()
    .min(3, "O nome deve ter no mínimo 3 caracteres")
    .refine(value => value.trim() !== "", "O nome não pode ser vazio"),

  email: z
    .string()
    .email("Email inválido")
    .refine(value => value.trim() !== "", "O email não pode ser vazio"),

  senha: z
    .string()
    .min(6, 'A senha deve ter no mínimo 6 caracteres')
    .regex(/[A-Z]/, 'A senha deve conter pelo menos uma letra maiúscula')
    .regex(/[a-z]/, 'A senha deve conter pelo menos uma letra minúscula')
    .regex(/\d/, 'A senha deve conter pelo menos um número'),

  perfis: z.object({
    id: z.number().int(),
    codigo: z.string().min(1, 'O perfil não pode ser vazio')
  }),

  

  idAcademia: z.number().int()

});

export type UsersFormData = z.infer<typeof usersSchema>;